import classNames from 'classnames'
import { useRouter } from 'next/router'
import { USL2WidgetHeading } from '@/revamp/pods/us-stocks/l2/components/widgets/heading'
import { StencilCDNImage } from '@/components/Common/StencilImage'
import Text from '@/stories/components/Common/NewText'
import { TRelatedBlogs } from '@/root/utils/articles/types'
import Link from '@/components/Common/Link'
import { DOMAIN } from '@/root/constants'
import { replaceS3SrcLinkWithCDNLink } from '@/root/utils/articles/replace-s3-src-with-cdn'
import { getLastUpdatedDate } from '@/revamp/pods/common/utils/get-last-update'

export default function RelatedBlogs({
  relatedBlogs,
  heading,
  isMobile,
  showLastUpdated = true,
}: {
  relatedBlogs: TRelatedBlogs
  heading?: string
  isMobile?: boolean | null
  showLastUpdated?: boolean
}) {
  const router = useRouter()
  if (!relatedBlogs?.length) return null
  return (
    <div>
      {heading && <USL2WidgetHeading>{heading}</USL2WidgetHeading>}

      <div className="flex flex-col gap-6">
        {!!relatedBlogs.length &&
          relatedBlogs.map((blog, idx) => {
            const isLast = idx === relatedBlogs.length - 1
            const navlink = `${DOMAIN}/blog/${
              blog?.preSlugPath?.preSlugPath
                ? `${blog.preSlugPath.preSlugPath}/`
                : ''
            }${blog?.slug}`

            return (
              <div
                key={blog?.id}
                className={classNames(
                  'flex cursor-pointer justify-between pb-3',
                  {
                    'border-grey-tertiary border-b': !isLast,
                  },
                )}
                onClick={() => {
                  void router.push(navlink)
                }}
              >
                <div className="flex flex-col gap-y-2 lg:w-3/4">
                  {blog?.title && (
                    <Text
                      appearance="subtitle2"
                      addClassName="tect-brand-black"
                    >
                      {blog.slug ? (
                        <Link href={navlink}>{blog.title}</Link>
                      ) : (
                        blog.title
                      )}
                    </Text>
                  )}
                  {blog?.description && (
                    <Text appearance="body1">{blog.description}</Text>
                  )}
                  {blog?.updated_at && showLastUpdated && (
                    <Text
                      appearance="caption"
                      addClassName="text-brand-grey-base"
                    >
                      Last Updated:{' '}
                      <time dateTime={blog.updated_at}>
                        {getLastUpdatedDate(blog.updated_at)}
                      </time>
                    </Text>
                  )}
                </div>

                {!isMobile && blog?.coverImage?.image?.formats?.small?.url && (
                  <StencilCDNImage
                    src={replaceS3SrcLinkWithCDNLink(
                      blog.coverImage.image.formats.small.url,
                    )}
                    width={150}
                    height={80}
                    alt={blog.coverImage.alt}
                    className="max-h-20 max-w-36 rounded-md"
                  />
                )}
              </div>
            )
          })}
      </div>
    </div>
  )
}
